import type { FaireProductEntity } from "../../entity_types/product";

export const p_6w3b55nwff: FaireProductEntity = {
  token: "p_6w3b55nwff",
  type: "product",
  name: "Tis The Season Diamond Air Mesh Shorts - Youth",
  brandToken: "b_1105vh61su",
  brandName: "Baseballism",
  imageUrl:
    "https://cdn.faire.com/fastly/495779572fa03a537355fc4bcb8096eadde8c94c60620d6fbf57cfa5a4970abe.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/37a9c021007d4d5dee2a18969dde76a7c382fd9be5afb794e9dbf99edad406d2.jpeg",
    "https://cdn.faire.com/fastly/7fc1a0d0ea85c570bcda1c85033eb9f8aea27314f8d7bd42ab3cce2c3102c0ef.jpeg",
    "https://cdn.faire.com/fastly/658048a3c8a3cf37c59a0f8f9a71a2683c1c6a5a8c56166261ca5dffb533cf91.jpeg",
    "https://cdn.faire.com/fastly/125f5db26427b0d32c0eb38fb9a8fff82fd9f4aae64f28e33be397b4a82869b4.jpeg",
  ],
  priceDollars: 24.5,
  description:
    "It's time to lock in and get geared up, baseball season is about to start!!\n\nFeatures:\n\n * Diamond Air Fine Mesh Fabric: Four-way stretch breathable and moisture-wicking, engineered for comfort whether you're on the move or relaxing.\n\n * Athleisure-Inspired Design: A perfect fusion of athletic functionality and casual style, ideal for everyday wear. \n * Extended Drawstrings: Extra-long drawstrings add a bold, streetwear touch while providing a secure, adjustable fit. \n * Signature Gold Aglets: Baseballism-branded gold aglets for a premium finish that complements the modern athleisure aesthetic. \n * Flag Man Jock Tag: A nod to baseball heritage, subtly incorporated into a sleek, contemporary design.\n\n * Pockets: Two side pockets and a rear zip pocket for light storage. \n * Side Slits: Designed for freedom of movement, these slits offer added flexibility without compromising the stylish look. \n\n",
  tags: [],
  msrpDollars: 49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:31.851Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
